module.exports = __webpack_public_path__ + "media/images/home-page/1-4-724f9114b4b5129a8bed04a2bdd5e009.png";